import { ShortlistWithScores } from "PFApp/components/resource_table_toggle/hooks/use_shortlist_items";
import { ColumnHelper } from "PFComponents/table/table.types";
import { Typography } from "PFComponents/typography";

import { MatchCell } from "./match_cell";

type CreateMatchColumnArgs = {
  headerLabel: string;
};

export const createMatchColumn = (
  columnHelper: ColumnHelper<ShortlistWithScores>,
  { headerLabel }: CreateMatchColumnArgs
) =>
  columnHelper.accessor((row) => row, {
    id: "match",
    header: () => (
      <Typography withMargin variant="labelRegular">
        {headerLabel}
      </Typography>
    ),
    cell: (info) => <MatchCell shortlist={info.getValue()} />,
    sortFn: (rowA, rowB) => {
      const scoreA = rowA.original.scores?.normalizedScore ?? 0;
      const scoreB = rowB.original.scores?.normalizedScore ?? 0;
      return scoreA - scoreB;
    },
    sortUndefined: "last",
    size: 40
  });
